<template>
  <v-layout row wrap>
    <YesNoModal ref="YesNoModal" />
    <ErrorModal ref="ErrorModal"></ErrorModal>
    <Loader ref="Loader"></Loader>
    <v-toolbar dense dark>
      <v-toolbar-title>Meeting - Create</v-toolbar-title>
    </v-toolbar>
    <v-container>
      <v-form ref="NewMeetingForm">
        <v-layout row wrap justify-center>
          <v-flex xs12 md10>
            <v-text-field label="Name" v-model="form.Name"></v-text-field>
            <v-text-field label="Subject" v-model="form.Subject"></v-text-field>
            <v-select label="Customer" :items="CustomerList" item-text="CustomerName" item-value="CustomerID"
              v-model="form.CustomerID" @change="fetchSystemUsers()">
            </v-select>
            <v-select multiple label="System Users" :items="SystemUserList" item-text="SystemUserFullName"
              item-value="SystemUserID" v-model="SelectedSystemUsers" :disabled="SystemUserList.length == 0"></v-select>
            <v-textarea label="Meeting Minutes"></v-textarea>
            <v-divider></v-divider>
            <v-layout row align-center>
              <v-subheader>Assigned Tasks: {{TaskList.length}}</v-subheader>
              <v-spacer></v-spacer>
              <v-btn small round color="success" @click="openTaskView(null)">
                Assign Tasks
                <v-icon small>mdi-plus</v-icon>
              </v-btn>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap justify-center>
              <v-flex x12>
                <v-list two-line subheader>
                  <v-list-tile v-for="item in TaskList" :key="item.Name">
                    <v-list-tile-content>
                      <v-list-tile-title>{{item.Name}}</v-list-tile-title>
                      <v-list-tile-sub-title>{{filterSystemUser(item.SystemUserID)}}</v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                      <v-btn icon @click="openTaskView(item)">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="SaveNewMeeting">Save</v-btn>
          <v-btn color="error" @click="cancelNewMeeting">Cancel</v-btn>
        </v-layout>
      </v-form>
    </v-container>

    <v-dialog width="500" v-model="taskDialog" persistent>
      <v-card>
        <v-toolbar dense dark>
          <v-toolbar-title>New Meeting Task</v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-subheader>Assigned Tasks: {{TaskList.length}}</v-subheader>
          <v-form ref="MeetingTaskForm">
            <v-layout row wrap justify-center>
              <v-flex xs12 md10>
                <v-text-field label="Task Name" v-model="MeetingTaskForm.Name"></v-text-field>
                <v-select label="User" :items="assignedSystemUsers" item-text="FullName" item-value="ID"
                  v-model="MeetingTaskForm.SystemUserID"></v-select>
                <v-layout ma-3>
                  <!-- <v-btn color="secondary" @click="startStream()">Upload image(s)</v-btn> -->
                  <input type="file" name="file" id="file" class="inputfile" accept="image/*" capture
                    @change="addImageFile" ref="myFile" />
                </v-layout>
              </v-flex>
            </v-layout>
            <transition name="fade">
              <span v-if="newTaskAssigned" style="color:green">Task Assigned!</span>
              <span v-if="taskUpdated" style="color:green">Task Updated!</span>
            </transition>

            <v-layout row>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="UpdateMeetingTask" v-if="taskDialogModify">Update Task</v-btn>
              <v-btn color="success" @click="AssignMeetingTask" v-else
                :disabled="MeetingTaskForm.Name == null || MeetingTaskForm.SystemUserID == null">Assign Task</v-btn>
              <v-btn color="success" @click="cancelMeetingTask">Done</v-btn>
            </v-layout>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>
    <v-layout>
      <v-dialog v-model="showPhotoDialog" width="800px">
        <v-card>
          <v-layout row wrap fill-height justify-center>
            <v-flex xs12>
              <video ref="video" class="camera-stream" />
            </v-flex>
            <v-flex xs12 text-xs-center>
              <v-btn class="take-picture-button" @click="capture" color="primary" dark fab>
                <v-icon>camera</v-icon>
              </v-btn>
              <!-- <v-btn class="switchCameraPosition" @click="switchCamera" color="secondary" dark fab>
                <v-icon>mdi-flip-to-back</v-icon>
              </v-btn> -->
            </v-flex>
            <v-dialog v-model="pictureDialog" width="500">
              <v-card>
                <v-layout>
                  <v-flex xs12>
                    <img :src="ImgCaptureSrc" alt width="100%">
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center>
                  <!-- <span v-if="!isWifi">**Cannot upload now, no wifi connection</span> -->
                  <v-btn color="primary" @click="pictureDialog = false">Ok</v-btn>
                  <!-- <v-btn color="secondary" @click="closeDialog()">Override</v-btn> -->
                </v-layout>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-layout>
</template>

<script>
  export default {
    data() {
      return {
        file: null,
        ImgCaptureSrc: "",
        showPhotoDialog: false,
        pictureDialog: false,
        taskDialog: false,
        taskDialogModify: false,
        newTaskAssigned: false,
        taskUpdated: false,
        form: {
          Name: null,
          Subject: null,
          CustomerID: null
        },
        MeetingTaskForm: {
          ID: null,
          Name: null,
          Image: null,
          FilePath: null,
          SystemUserID: null,
          MeetingID: null,
          Complete: false
        },
        SelectedSystemUsers: [],
        assignedSystemUsers: [],
        TaskList: [],
        CustomerList: [],
        SystemUserList: [],
        rootPath: "",
        systemUserID: 0,
        meetingSystemUsers: [],
        MeetingDetailAssigned: {},
        CanFetch: false,
      };
    },
    mounted() {
      this.checkConnection();
      setTimeout(() => {
        if (this.CanFetch == true) {
          this.systemUserID = parseInt(localStorage.getItem('USER_ID'));
          console.log('userID', this.systemUserID)
          this.fetchCustomers();
          //this.fetchSystemUsers();
        } else {
          this.$refs.ErrorModal.setText("No internet connection.");
          this.$refs.ErrorModal.show();
          setTimeout(() => {
            this.$router.go(-1)
          }, 1200)
        }
      }, 100)

      this.rootPath = this.$route.matched[0].path;
    },
    methods: {
      checkConnection(e) {
        let self = this;
        try {
          var connection =
            navigator.connection ||
            navigator.mozConnection ||
            navigator.webkitConnection;
          var type = connection.type;
          if (connection) {
            //CONNECTED VIA PC
            if (connection.type === undefined) {
              console.log("[CONNECTED VIA PC]");
              this.CanFetch = true;
            }

            //MOBILE
            if (connection.type === "cellular") {
              this.CanFetch = true;
              console.log("[CONNECTED VIA MOBILE] - CELLULAR");
            } else if (connection.type === "wifi") {
              this.CanFetch = true;
              console.log("[CONNECTED VIA MOBILE] - WIFI");
            }
            console.log("[CONNECTION TYPE]", connection);
          }
        } catch (error) {
          this.CanFetch = false;
          console.warn(
            "[CONNECTION TYPE] IOS, could not determine connection type for safari. Will use any form of data to upload",
            error, error.toString());
        }
      },
      addImageFile() {
        let self = this;
        self.file = self.$refs.myFile.files[0];
        console.log("[IMAGE DATA]", self.file)

        self.$nextTick(() => {
          var image = null;
          var reader = new FileReader();
          reader.readAsArrayBuffer(self.file);
          reader.onload = function () {
            image = Array.from(new Uint8Array(reader.result));
            console.log("[img?]", image);
            self.MeetingTaskForm.Image = image;
            //self.MeetingTaskForm.Image = self.imgByteArr;
          };
        })
      },
      fetchCustomers() {
        let self = this;

        self.get(`CustomerUserLink/GetIntData?systemUserID=${self.systemUserID}`).then(r => {
          console.log(r.data)
          self.CustomerList = r.data;
        });
      },
      fetchSystemUsers() {
        let self = this;

        console.log("selected customer", self.form.CustomerID)
        self.get(`CustomerUserLink/GetIntData?customerID=${self.form.CustomerID}`).then(r => {
          console.log("CUSTOMER-USER LINK", r.data)
          self.SystemUserList = r.data;
        })
      },
      // fetchCustomers() {
      //   let self = this;
      //   self.CustomerList = [];

      //   // self.get(`Customer`).then(r => {
      //   //   self.CustomerList = r.data;
      //   // });
      //   self.get(`CustomerUserLink/GetIntData?systemUserID=${self.systemUserID}`).then(r => {
      //     r.data.forEach(link => {
      //       self.CustomerList.push({
      //         Name: link.CustomerName,
      //         ID: link.CustomerID
      //       })
      //     })
      //   })
      // },
      // fetchSystemUsers() {
      //   let self = this;

      //   self.get(`SystemUser/getAll`).then(r => {
      //     self.SystemUserList = r.data;
      //     console.log("system users", self.SystemUserList)
      //   });
      // },
      openTaskView(item) {
        let self = this;
        self.assignedSystemUsers = [];
        console.log("selected system users", self.SelectedSystemUsers)

        self.SelectedSystemUsers.forEach(user => {
          self.get(`SystemUser?id=${user}`).then(r => {
            console.log("selecte dsystem user", r)
            self.assignedSystemUsers.push(r.data)
          })
        })

        if (item != null) {
          self.MeetingTaskForm = Object.assign({}, item);
          self.taskDialogModify = true;
        } else {
          self.taskDialogModify = false;
        }

        self.taskDialog = true;
      },
      UpdateMeetingTask() {
        let self = this;

        var newObj = Object.assign({}, self.MeetingTaskForm);

        self.taskUpdated = true;
        setTimeout(() => {
          self.taskUpdated = false;
        }, 1500);

        var prevItem = self.TaskList.find(el => {
          return el.ID == newObj.ID;
        });

        var index = self.TaskList.indexOf(prevItem);

        self.TaskList.splice(index, 1, newObj);

        self.$nextTick(() => {
          self.$refs.MeetingTaskForm.reset();
          self.taskDialogModify = false;
        });
      },
      AssignMeetingTask() {
        let self = this;

        self.newTaskAssigned = true;
        setTimeout(() => {
          self.newTaskAssigned = false;
        }, 1500);

        var newObj = Object.assign({}, self.MeetingTaskForm);
        newObj.ID = self.TaskList.length + 1;
        self.TaskList.push(newObj);
        self.$refs.MeetingTaskForm.reset();
        self.file = null;
        document.getElementById("file").value = "";
      },
      cancelMeetingTask() {
        let self = this;

        self.$refs.MeetingTaskForm.reset();
        self.taskDialog = false;
        self.file = null;
        document.getElementById("file").value = "";
      },
      SaveNewMeeting() {
        let self = this;

        let request = {
          MeetingDetail: self.form,
          MeetingTasks: self.TaskList,
          SystemUserLinks: self.SelectedSystemUsers
        };
        console.log("[MEETING TASK REQUEST]", request)
        self.post(`Meeting/PostComplex`, request).then(r => {
          console.log(r.data)
          if (r.data != null) {
            //self.SendMeetingEmail(request, r.data);
            self.file = null;
            document.getElementById("file").value = "";
            self.$router.push(`${this.rootPath}/Meeting`);
          }
        })
      },
      SendMeetingEmail(request, data) {
        let self = this;
        console.log("[MEETING DATA TO EMAIL]", data.MeetingTasks)

        data.MeetingTasks.forEach(item => {
          console.log("task item", item)

          let systemUser = self.SystemUserList.find(filter => {
            return filter.ID == item.SystemUserID;
          });
          console.log("system user", systemUser)

          let header = request.MeetingDetail.Name + ' - ' + request.MeetingDetail.Subject;

          let Request = {
            ContentDetails: {
              SystemUser: systemUser.FullName,
              MeetingHeader: header,
              MeetingTaskList: item.Name
            },
            FromAddress: "feedback@suburbanserv.co.za",
            Subject: "SuburbanServ has a new meeting task for you!",
            ToList: systemUser.ContactEmail
          }

          console.log("[REQUEST TO EMAIL]", Request);
          self.post(`sendgrid/send/meeting`, Request).then(r => {
            console.log("[EMAIL SENT]", r.data)
          })
        });
      },
      cancelNewMeeting() {
        let self = this;

        self.$router.push(`${this.rootPath}/Meeting`);
      },
      filterSystemUser(systemUserID) {
        let self = this;

        let systemUser = self.SystemUserList.find(filter => {
          return filter.ID == systemUserID;
        });

        if (systemUser != undefined) {
          return systemUser.FirstName + " " + systemUser.LastName;
        }
      },
      startStream() {
        let self = this;
        self.imgByteArr = null;
        self.showPhotoDialog = true;
        const constraints = {
          video: {
            facingMode: self.shouldFaceUser ? "user" : "environment"
          }
        };

        navigator.mediaDevices.getUserMedia(constraints).then(stream => {
          this.mediaStream = stream;
          this.$refs.video.srcObject = stream;
          this.$refs.video.play();
        });
      },
      capture() {
        let self = this;
        var newBlob = null;
        self.showPhotoDialog = false;
        self.$refs.Loader.show();
        self.$refs.Loader.setText("Capturing Image");

        const vm = this;
        const mediaStreamTrack = this.mediaStream.getVideoTracks()[0];
        const imageCapture = new window.ImageCapture(mediaStreamTrack);
        // return imageCapture.takePhoto().then(blob => {
        //   var reader = new FileReader();
        //   self.newBlob = blob;
        //   reader.readAsDataURL(blob);
        //   reader.onloadend = function () {
        //     self.pictureDialog = true;
        //     self.ImgCaptureSrc = reader.result;
        //   };
        //   self.ConvertImgToByteArr();
        // });

        return imageCapture
          .grabFrame()
          .then(imageBitmap => {
            const canvas = document.createElement("canvas");
            canvas.getContext("2d");
            // resize it to the size of our ImageBitmap
            canvas.width = imageBitmap.width;
            canvas.height = imageBitmap.height;
            setTimeout(() => {
              // try to get a bitmaprenderer context
              let ctx = canvas.getContext("bitmaprenderer");
              canvas.getContext("2d").drawImage(imageBitmap, 0, 0);

              if (ctx) {
                // transfer the ImageBitmap to it
                ctx.transferFromImageBitmap(imageBitmap);
              } else {
                // in case someone supports createImageBitmap only
                // twice in memory...
                canvas.getContext("2d").drawImage(imageBitmap, 0, 0);
              }
              // get it back as a Blob
              canvas.toBlob(
                function (blob) {
                  var reader = new FileReader();
                  self.newBlob = blob;
                  reader.readAsDataURL(blob);
                  reader.onloadend = function () {
                    self.pictureDialog = true;
                    self.ImgCaptureSrc = reader.result;
                  };
                  self.ConvertImgToByteArr();
                },
                "image/png",
                1
              );

              self.$refs.Loader.hide();
            }, 2000);
          })
          .catch(error => {
            console.error("grabFrame() error:", error)

            self.$refs.Loader.hide();
            self.$refs.ErrorModal.show();
            self.$refs.ErrorModal.setText("Failed to take photo. Error: ", error);
          });
      },
      switchCamera() {
        const tracks = this.mediaStream.getTracks();
        tracks.map(track => track.stop());
        // toggle / flip
        this.shouldFaceUser = !this.shouldFaceUser;
        this.startStream();
      },
      ConvertImgToByteArr() {
        let self = this;
        // convert to byte array
        var reader = new FileReader();
        reader.readAsArrayBuffer(self.newBlob);
        reader.onload = function () {
          self.pictureDialog = true;

          self.imgByteArr = Array.from(new Uint8Array(reader.result));
          console.log(self.imgByteArr);

          self.MeetingTaskForm.Image = self.imgByteArr;
        };
      },
    }
  };
</script>

<style scoped>
  .camera-modal {
    width: 100%;
    height: 100%;
    top: 20;
    left: 0;
    position: absolute;
    background-color: white;
    z-index: 10;
  }

  .camera-stream {
    width: 100%;
    max-height: 100%;
  }

  .camera-modal-container {
    position: absolute;
    top: 0;
    width: 100%;
    height: 90%;
    margin-bottom: 24px;
  }

  .inputfile+label {
    font-size: 1.25em;
    font-weight: 700;
    color: white;
    background-color: black;
    display: inline-block;
  }
</style>